module.exports = "<iframe id=\"pdfFrame\" [src]=\"edocLink | safeUrl\"\n        seamless=\"seamless\" [title]=\"'circuit.edoc.title' | translate\"\n        class=\"pdf-frame\">\n</iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/lbpa-edoc/lbpa-edoc.component.html
// module id = NLQc
// module chunks = 1